// src/utils/api.js
import axios from 'axios';

// 1. Point everything to the /api/v1 prefix based on your screenshot
const BASE_URL = 'http://127.0.0.1:8000/api/v1'; 

const api = axios.create({
  baseURL: BASE_URL,
});

// Add a request interceptor to include the Token in every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const loginAdmin = async (username, password) => {
    // FastAPI OAuth2PasswordRequestForm expects form-data
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);

    // 2. Updated to use the correct path found in your screenshot
    // It will now request: http://127.0.0.1:8000/api/v1/auth/token
    const response = await axios.post(`${BASE_URL}/auth/token`, params, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
    return response.data;
};

export default api;